module.exports = __webpack_public_path__ + "media/images/lp_mv-pc-43821e6c74aab3f8d7b148766aa2bef7.webp";